// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only.

import type { ReactNode } from 'react'
import Box from '@mui/material/Box'
import Chip from '@mui/material/Chip'
import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'

export interface AppTab { value: string; label: ReactNode; badge?: string }

/** D-UI-3 — the kit's tab strip (pages import the kit, never @mui directly). Optional small badge, e.g. "beta". */
export default function AppTabs({ value, onChange, tabs, ariaLabel }: {
  value: string; onChange: (value: string) => void; tabs: AppTab[]; ariaLabel?: string
}) {
  return (
    <Tabs value={value} onChange={(_, v: string) => onChange(v)} aria-label={ariaLabel}
      sx={{ px: 2.5, borderBottom: 1, borderColor: 'divider', minHeight: 40, '& .MuiTab-root': { minHeight: 40, textTransform: 'none' } }}>
      {tabs.map(t => (
        <Tab key={t.value} value={t.value} label={t.badge
          ? <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>{t.label}<Chip size="small" label={t.badge} color="primary" variant="outlined" sx={{ height: 18, fontSize: 10 }} /></Box>
          : t.label} />
      ))}
    </Tabs>
  )
}
